// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeLegalEntityCompanyArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiLegalEntityCompanyStructureEnum,
  OpenapiLegalEntityCompanyVatRegistrationStatusEnum,
  OpenapiLegalEntityCompanyOwnershipExemptionReasonEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {legalEntityCompanyVerificationFragment} from './legalEntityCompanyVerificationFragment';
import {legalEntityAddressArkFragment} from './legalEntityAddressArkFragment';
import {legalEntityJapanAddressArkFragment} from './legalEntityJapanAddressArkFragment';
import {legalEntityCompanyStockArkFragment} from './legalEntityCompanyStockArkFragment';

import type {LegalEntityAddressArkFragmentData} from './legalEntityAddressArkFragment';
import type {LegalEntityJapanAddressArkFragmentData} from './legalEntityJapanAddressArkFragment';
import type {LegalEntityCompanyVerificationFragmentData} from './legalEntityCompanyVerificationFragment';
import type {LegalEntityCompanyStockArkFragmentData} from './legalEntityCompanyStockArkFragment';

const doc = gql`
  fragment StripeLegalEntityCompanyArkFragment on OpenapiLegalEntityCompany {
    address {
      ...LegalEntityAddressArkFragment
    }
    address_kana {
      ...LegalEntityJapanAddressArkFragment
    }
    address_kanji {
      ...LegalEntityJapanAddressArkFragment
    }
    contact_point_verification_address {
      ...LegalEntityAddressArkFragment
    }
    cross_border_transaction_classifications
    directors_provided
    directorship_declaration {
      ip
      date
    }
    executives_provided
    fiscal_code_provided
    name
    name_kana
    name_kanji
    owners_provided
    ownership_exemption_reason
    phone
    registered_email
    structure
    tax_id
    tax_id_last_4
    tax_id_provided
    vat_id_provided
    verification {
      ...LegalEntityCompanyVerificationFragment
    }
    verified
    export_license_id
    export_purpose_code
    vat_registration_status
    tax_deduction_account_number
    registration_number
    registration_date {
      day
      month
      year
    }
    stock_data {
      ...LegalEntityCompanyStockArkFragment
    }
  }

  ${legalEntityCompanyStockArkFragment}
  ${legalEntityCompanyVerificationFragment}
  ${legalEntityAddressArkFragment}
  ${legalEntityJapanAddressArkFragment}
`;

export const stripeLegalEntityCompanyArkFragment: StripeLegalEntityCompanyArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeLegalEntityCompanyArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityCompany';
  readonly cross_border_transaction_classifications: ReadonlyArray<string> | null;
  readonly directors_provided: boolean | null;
  readonly executives_provided: boolean | null;
  readonly fiscal_code_provided: boolean | null;
  readonly name: string | null;
  readonly name_kana: string | null;
  readonly name_kanji: string | null;
  readonly owners_provided: boolean | null;
  readonly ownership_exemption_reason: OpenapiLegalEntityCompanyOwnershipExemptionReasonEnum | null;
  readonly phone: string | null;
  readonly registered_email: string | null;
  readonly structure: OpenapiLegalEntityCompanyStructureEnum | null;
  readonly tax_id: string | null;
  readonly tax_id_last_4: string | null;
  readonly tax_id_provided: boolean | null;
  readonly vat_id_provided: boolean | null;
  readonly verified: boolean | null;
  readonly export_license_id: string | null;
  readonly export_purpose_code: string | null;
  readonly vat_registration_status: OpenapiLegalEntityCompanyVatRegistrationStatusEnum | null;
  readonly tax_deduction_account_number: string | null;
  readonly registration_number: string | null;
  readonly address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityAddress'},
    [LegalEntityAddressArkFragmentData]
  > | null;
  readonly address_kana: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressArkFragmentData]
  > | null;
  readonly address_kanji: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressArkFragmentData]
  > | null;
  readonly contact_point_verification_address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityAddress'},
    [LegalEntityAddressArkFragmentData]
  > | null;
  readonly directorship_declaration: {
    readonly __typename: 'OpenapiLegalEntityDirectorshipDeclaration';
    readonly ip: string | null;
    readonly date: number | null;
  } | null;
  readonly verification: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityCompanyVerification'},
    [LegalEntityCompanyVerificationFragmentData]
  > | null;
  readonly registration_date: {
    readonly __typename: 'OpenapiLegalEntityRegistrationDate';
    readonly day: number | null;
    readonly month: number | null;
    readonly year: number | null;
  } | null;
  readonly stock_data: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityCompanyStockData'},
    [LegalEntityCompanyStockArkFragmentData]
  > | null;
};

export type StripeLegalEntityCompanyArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeLegalEntityCompanyArkFragmentPermissions = {
  ...legalEntityAddressArkFragment.permissions,
  ...legalEntityCompanyStockArkFragment.permissions,
  ...legalEntityCompanyVerificationFragment.permissions,
  ...legalEntityJapanAddressArkFragment.permissions,
} as const;

doc.permissions = stripeLegalEntityCompanyArkFragmentPermissions;

export type StripeLegalEntityCompanyArkFragmentPermissions = V1PermissionToken<
  typeof stripeLegalEntityCompanyArkFragmentPermissions
>;

export type StripeLegalEntityCompanyArkFragmentDocument = GraphQlDocument<
  StripeLegalEntityCompanyArkFragmentData,
  StripeLegalEntityCompanyArkFragmentVariables,
  StripeLegalEntityCompanyArkFragmentPermissions
>;
